  
import {useState,useEffect} from 'react';
import {auth,db} from '.././dashboard/firebase/firebase';
import {initializeApp} from 'firebase/app'
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import queryString from 'query-string';
import {useNavigate} from 'react-router-dom';
import { doc, setDoc, getDocs, collection,getDoc ,query, addDoc, where, updateDoc} from "firebase/firestore";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { de_encrypt } from '../../encryption';
const Process =()=>{
  const navigate = useNavigate();
  const url= queryString.parse(window.location.search);
  
  const admin =['owoadeanuoluwapo2@gmail.com','ogbonnaemmanuel494@gmail.com','Psalmsheg@gmail.com','aowoade749@stu.ui.edu.ng'];
  const [lin,setLin]=useState(false);
  if(url.admin != undefined){
     if(!(admin.includes(de_encrypt(url.admin)))){
       navigate('/admin');
      }
  }else{
    navigate('/admin');
   }

  const [pending,setPending]=useState(null);
  const [approved, setApproved]=useState(null);
  const [clicked, setClicked] = useState(false)
  const all_approved=[];
  const all_pending=[];
  const [info,setInfo]=useState(null)
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: "#9900EF",
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14
        },
      }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));   
    
    
  useEffect(()=>{
       if(pending==null){
            ( async ()=>{
            const q = query(collection(db, "withdrawal"), where("status", "==", "pending"));
                    const querySnapshot = await getDocs(q);
                    querySnapshot.forEach((doc) => {
                        all_pending.push({id: doc.id, data:doc.data()})
             });
             setPending(all_pending.sort((a,b)=>{return b.data.time - a.data.time}))
           })()
            
      } 
    },[pending])
useEffect(()=>{
       if(approved==null){
            ( async ()=>{
            const q = query(collection(db, "withdrawal"), where("status", "==", "approved"));
                    const querySnapshot = await getDocs(q);
                    querySnapshot.forEach((doc) => {
                        all_approved.push({id: doc.id, data:doc.data()})
             });
             setApproved(all_approved.sort((a,b)=>{return b.data.time - a.data.time}))
           })()
            
      } 
    },[approved])
  const today = new Date()
  const approve =async (amount,id,email,type)=>{
    setClicked(true)
   const u_data = {
                    withdrawal:false,
                    debit_type:type,
                    debit_amount:amount
                  }
   const wRef = doc(db, "withdrawal", id);
   const uRef = doc(db, "user",email)
                       const w_data = {
                         status: 'approved',
                         date_approved:`${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()} ${today.getHours()}:${today.getMinutes()}`,
                      }    
                      

   const notification_data={
    type:'withdrawal',
    subject:`Withdrawal request`,
    body:`Your withdrawal request of ${amount} naira has been approved.`,
    time:Date.now(),
    to:email
   }
   await  updateDoc(wRef, w_data);
   await  updateDoc(uRef,u_data);
   await  addDoc(collection(db, "notifications"), notification_data)
   alert(true)
   setClicked(false);
   setPending(null);
  }
  const decline = async (id,email,amount)=>{
    setClicked(true)
   const wRef = doc(db, "withdrawal", id);
          const uRef = doc(db, "user",email)
                       const w_data = {
                         status: 'declined',
                      }    
    const u_data= {withdrawal:false}  
    const notification_data={
                            type:'withdrawal',
                            subject:`Withdrawal request`,
                            body:`Your withdrawal request of ${amount} naira was declined, kindly check your account details.`,
                            time:Date.now(),
                            to:email
                        }  
             
                   await updateDoc(wRef, w_data);
                  await updateDoc(uRef,u_data); 
                  const nRef = await addDoc(collection(db, "notifications"), notification_data);
                  setPending(null)
  }
   
  return (
    <div className="admin-container">
    
      
     <div className="main-admin">
      
         <h3>Pending withdrawals </h3>

         {  pending &&  <div className="box">
          <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                        <TableRow>
                            <StyledTableCell>Email</StyledTableCell>
                            <StyledTableCell align="center">Amount</StyledTableCell>
                            <StyledTableCell align="center">Bank details</StyledTableCell>
                            <StyledTableCell align="center">Description</StyledTableCell>
                            <StyledTableCell align="center">Date&nbsp;</StyledTableCell>
                            <StyledTableCell align="center">Action&nbsp;</StyledTableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {pending.map((row,index) => (
                            <StyledTableRow key={row.name}>
                            <StyledTableCell component="th" scope="row">
                                {row.data.email}
                            </StyledTableCell>
                            <StyledTableCell align="center">{row.data.amount}</StyledTableCell>
                            <StyledTableCell align="center">({row.data.acct_name}) ({row.data.acct_num}) ({row.data.bank_name}) </StyledTableCell>
                            <StyledTableCell align="center">{row.data.desc}</StyledTableCell>
                            <StyledTableCell align="center">{row.data.date}</StyledTableCell>
                            <StyledTableCell align="center">{!clicked ? <button onClick={()=>{approve(row.data.amount, row.id,row.data.email,row.data.type)}}>Approve</button> : <button> processing </button>}</StyledTableCell>
                            <StyledTableCell align="center">{!clicked ? <button onClick={()=>{decline(row.id,row.data.email,row.data.amount)}}>Decline</button> : <button>processing </button>}</StyledTableCell>
                            </StyledTableRow>
                        ))}
                        </TableBody>
                    </Table>
                    </TableContainer> 
          
        
        </div> }
          
       
        <h3>Approved withdrawals </h3>

         {  approved &&  <div className="box">
          <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                        <TableRow>
                            <StyledTableCell>Email</StyledTableCell>
                            <StyledTableCell align="center">Amount</StyledTableCell>
                            <StyledTableCell align="center">Bank details</StyledTableCell>
                            <StyledTableCell align="center">Description</StyledTableCell>
                            <StyledTableCell align="center">Date&nbsp;</StyledTableCell>
                            <StyledTableCell align="center">Action&nbsp;</StyledTableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {approved.map((row,index) => (
                            <StyledTableRow key={row.name}>
                            <StyledTableCell component="th" scope="row">
                                {row.data.email}
                            </StyledTableCell>
                            <StyledTableCell align="center">{row.data.amount}</StyledTableCell>
                            <StyledTableCell align="center">{row.data.status}</StyledTableCell>
                            <StyledTableCell align="center">{row.data.desc}</StyledTableCell>
                            <StyledTableCell align="center">{row.data.date_approved}</StyledTableCell>
                            
                            </StyledTableRow>
                        ))}
                        </TableBody>
                    </Table>
                    </TableContainer> 
          
        
        </div> }
          
      
       
    
    </div> 
    
    </div>
  )
}
export default Process
